import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Auto-dismiss after 5 seconds
    this.timeout = setTimeout(() => {
      this.dismiss()
    }, 5000)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    const alert = this.element

    // Use Bootstrap's alert close if available
    if (typeof $(alert).alert === 'function') {
      $(alert).alert('close')
    } else {
      // Fallback: fade out and remove
      alert.style.transition = 'opacity 0.3s ease'
      alert.style.opacity = '0'
      setTimeout(() => {
        alert.remove()
      }, 300)
    }
  }
}